var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v("基本信息 "),
          _c(
            "template",
            { slot: "right" },
            [
              !_vm.isView
                ? [
                    _c("el-button", { on: { click: _vm.tryCancel } }, [
                      _vm._v(_vm._s(_vm.$t("cancelText"))),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleConfirm },
                      },
                      [_vm._v(_vm._s(_vm.$t("saveText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? [
                    _c(
                      "el-button",
                      { attrs: { type: "primary" }, on: { click: _vm.cancel } },
                      [_vm._v(_vm._s(_vm.$t("backText")))]
                    ),
                  ]
                : _vm._e(),
              _vm.isView
                ? _c("BjLogButton", {
                    attrs: {
                      id: _vm.form.id,
                      permission:
                        _vm.GOODS_COMBO_TYPES.ORDINARY === _vm.form.setFlag
                          ? "BusinessGoodsSpuOrdinary_Log"
                          : "BusinessGoodsSpuPackage_Log",
                      title: _vm.form.name,
                      api: "goodsApi",
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "100px" },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "组合类型", prop: "setFlag" } },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.GOODS_COMBO_TYPE_LIST.bjGet(_vm.form.setFlag)
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品类型", prop: "type" } },
                    [
                      !_vm.isView
                        ? _c("BjRadioLov", {
                            attrs: {
                              "option-list": _vm.GOODS_TYPE_LIST,
                              placeholder: _vm.$t("chooseText"),
                            },
                            model: {
                              value: _vm.form.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "type", $$v)
                              },
                              expression: "form.type",
                            },
                          })
                        : _vm._e(),
                      _vm.isView
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(_vm.GOODS_TYPE_LIST.bjGet(_vm.form.type))
                              )
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.spuName"),
                        prop: "name",
                      },
                    },
                    [
                      !_vm.isView
                        ? _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          })
                        : _vm._e(),
                      _vm.isView
                        ? _c("span", [_vm._v(_vm._s(_vm.form.name))])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("BjFormItemCode", {
                    attrs: {
                      required: "",
                      readonly: !_vm.isAdd,
                      label: "商品编码",
                      prop: "spuCode",
                    },
                    model: {
                      value: _vm.form.spuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "spuCode", $$v)
                      },
                      expression: "form.spuCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("goodsPage.categoryName"),
                        prop: "categoryId",
                      },
                    },
                    [
                      _vm.isAdd
                        ? _c("BjGoodsTypeTreeSelect", {
                            attrs: {
                              query: { statusFlag: true },
                              "only-leaf": "",
                              "expand-all": "",
                            },
                            model: {
                              value: _vm.form.categoryId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "categoryId", $$v)
                              },
                              expression: "form.categoryId",
                            },
                          })
                        : _vm._e(),
                      !_vm.isAdd
                        ? _c("span", [_vm._v(_vm._s(_vm.form.categoryName))])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.form.setFlag == _vm.GOODS_COMBO_TYPES.ORDINARY
                ? _c(
                    "el-col",
                    { attrs: { span: _vm.colSpan } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌", prop: "brandId" } },
                        [
                          !_vm.isView
                            ? _c("BjSelectBrand", {
                                attrs: {
                                  "default-options": {
                                    label: _vm.form.brandName,
                                    value: _vm.form.brandId,
                                  },
                                },
                                model: {
                                  value: _vm.form.brandId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "brandId", $$v)
                                  },
                                  expression: "form.brandId",
                                },
                              })
                            : _vm._e(),
                          _vm.isView
                            ? _c("span", [_vm._v(_vm._s(_vm.form.brandName))])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("table.remarkText"),
                        prop: "remark",
                      },
                    },
                    [
                      !_vm.isView
                        ? _c("BjInput", {
                            attrs: {
                              maxlength: _vm.MAX_LENGTH.DEFAULT,
                              placeholder: _vm.$t("inputText"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          })
                        : _vm._e(),
                      _vm.isView
                        ? _c("span", [_vm._v(_vm._s(_vm.form.remark))])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("GoodsAttributeList", {
            ref: "GoodsAttributeList",
            attrs: {
              "parent-id": _vm.form.categoryId,
              "is-view": _vm.isView,
              "is-spu": "",
              "set-flag": _vm.form.setFlag,
            },
          }),
          _c("BjDivider", [_vm._v("商品图片")]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "素材名称", prop: "materialId" } },
                    [
                      !_vm.isView
                        ? _c("BjSelectMaterial", {
                            attrs: {
                              "default-options": {
                                label: _vm.form.materialName,
                                value: _vm.form.materialId,
                              },
                            },
                            model: {
                              value: _vm.form.materialId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "materialId", $$v)
                              },
                              expression: "form.materialId",
                            },
                          })
                        : _vm._e(),
                      _vm.isView
                        ? _c("span", [_vm._v(_vm._s(_vm.form.materialName))])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-form-item", { attrs: { label: "主图" } }, [
                _c(
                  "div",
                  { staticClass: "flex flex-spacebetween" },
                  _vm._l(_vm.materialInfo.mainImage || [], function (url, i) {
                    return _c("BjViewUrl", {
                      key: i,
                      staticClass: "flex-item",
                      attrs: { url: url },
                    })
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-form-item", { attrs: { label: "详情图" } }, [
                _c(
                  "div",
                  { staticClass: "flex flex-spacebetween" },
                  _vm._l(_vm.materialInfo.detailImage || [], function (url, i) {
                    return _c("BjViewUrl", {
                      key: i,
                      staticClass: "flex-item",
                      attrs: { url: url },
                    })
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }